import { CheckCircle } from 'lucide-react'
import { AuthLayout } from '@/modules/auth/ui/components'
import { AppStoreBadges } from '@/shared/ui/components'
import { Button } from '@/shared/ui/primitives'

export type SuccessStateProps = {
  organizationName: string
  onSignOut: () => void
}

export function SuccessState({ organizationName, onSignOut }: SuccessStateProps) {
  return (
    <AuthLayout
      title="You're all set!"
      subtitle={`Welcome to ${organizationName}.`}
    >
      <div className="flex flex-col items-center gap-4 text-center">
        <CheckCircle className="size-12 text-primary" aria-hidden />
        <p className="text-sm text-muted-foreground">
          Download the BlindBook app and sign in with your email to get started.
        </p>
        <div className="pt-2">
          <AppStoreBadges />
        </div>
        <Button type="button" variant="ghost" size="sm" onClick={onSignOut} className="mt-2">
          Sign out
        </Button>
      </div>
    </AuthLayout>
  )
}
